module.exports = __webpack_public_path__ + "img/logo_StockRadars(black).31572dce.png";